import MaterialIcon from "../../../components/BuilderComponents/MaterialIcon";
import { getToolTipAttributes } from "../../../utils/tooltip";
import { getTypeIcon } from "../config";
import UserAvatar from "./UserAvatar";

const MAX_VISIBLE_AVATARS = 5;

const RoleInfo = ({ label, type, users = [], meta }) => {
  const isUserType = type === "USER";
  const hasUsers = users && users.length > 0;

  const visibleUsers = hasUsers ? users.slice(0, MAX_VISIBLE_AVATARS) : [];
  const remainingCount = hasUsers ? users.length - MAX_VISIBLE_AVATARS : 0;

  const remainingNames =
    remainingCount > 0
      ? users
          .slice(MAX_VISIBLE_AVATARS)
          .map((u) => u.name)
          .join(", ")
      : "";

  return (
    <div className="d_flex gap_2 align_center">
      <div className="d_flex align_center gap_1">
        <span className="font_size_xsmall text_transform_uppercase">{label}</span>

        {meta && (
          <MaterialIcon
            name="info"
            className="font_size_small"
            style={{ fontSize: "14px" }}
            {...getToolTipAttributes(meta)}
          />
        )}
      </div>

      <div className="d_flex align_center" style={{ height: "28px" }}>
        {isUserType && hasUsers ? (
          <div className="d_flex align_center">
            {visibleUsers.map((user, index) => (
              <div key={user.email || index} style={{ marginLeft: index === 0 ? "0" : "-8px", zIndex: 10 - index }}>
                <UserAvatar name={user.name} />
              </div>
            ))}

            {remainingCount > 0 && (
              <div
                className="d_flex justify_center align_center border_radius_circle color_secondary font_size_medium cursor_default"
                style={{
                  width: "28px",
                  height: "28px",
                  minWidth: "28px",
                  border: "2px solid white",
                  marginLeft: "2px",
                  zIndex: 0
                }}
                {...getToolTipAttributes(`${remainingCount} more: ${remainingNames}`)}
              >
                +{remainingCount}
              </div>
            )}
          </div>
        ) : (
          <div className="d_flex align_center gap_2">
            <MaterialIcon name={getTypeIcon(type)} className="color_primary" style={{ fontSize: "20px" }} />
            <span className="font_size_small font_weight_medium">{type}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default RoleInfo;
